// cleanup_convert_to_typescript_file_GENERICS
// cleanup_class_to_function_GENERICS
// cleanup_hoc_to_hooks_GENERICS

import React, { lazy, Suspense, Component } from 'react';
import PropTypes from 'prop-types';

import Alert from '@glu/alerts-react';

import { ALERTVARIATIONS } from 'constants.js';
import { logEvent } from 'api/audits/service';
import withLocale from 'components/withLocale/withLocale';
import withAppStyles from 'components/withAppStyles/withAppStyles';
import Spinner from 'components/spinner/Spinner';
import { JSSClasses } from 'proptypes/jss-prop-types';

import nativeStyles from './widget.native.styles';
import styles from './widget.styles';

const laziness = (path) =>
  lazy(() => import(/* webpackExclude: /\.spec\.(js|js\.snap)$/ */ `../widgets/${path}`));

export class WidgetComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      errorMessage: '',
      Widget: null
    };
  }

  componentDidMount() {
    const { locale, name, path } = this.props;
    logEvent({ subSvc: locale['common.widget'], message: name });
    this.setState({ loading: false, Widget: laziness(path) });
  }

  componentDidCatch = (error, info) => {
    const { locale } = this.props;

    // eslint-disable-next-line
    console.error(error, info);

    this.setState({ errorMessage: locale['common.widget.crash'] });
  };

  render() {
    const {
      classes: { body },
      id,
      lock,
      name,
      path,
      ...props
    } = this.props;
    const { Widget, errorMessage, loading } = this.state;

    if (errorMessage) {
      return (
        <div className={body}>
          <Alert
            dataQa="widget-alert"
            variant={ALERTVARIATIONS.ERROR}
            dismissible={false}
            message={errorMessage}
          />
        </div>
      );
    }

    return (
      <div className={body}>
        {loading ? (
          <Spinner />
        ) : (
          <Suspense fallback={<Spinner />}>
            <Widget {...props} />
          </Suspense>
        )}
      </div>
    );
  }
}

WidgetComponent.defaultProps = {
  classes: {},
  id: '',
  locale: {},
  lock: false
};

WidgetComponent.propTypes = {
  classes: JSSClasses,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  locale: PropTypes.objectOf(PropTypes.string),
  lock: PropTypes.bool,
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired
};

const WidgetStyled = withAppStyles({ web: styles, native: nativeStyles }, WidgetComponent);
export default withLocale(WidgetStyled);
